
import {
  Component, PropSync, Mixins,
} from 'vue-property-decorator';
import focusMixin from '@/features/common/mixins/focusMixin';
import moment from 'moment';
import FreightOptions, { ShipFromType, ShipToType } from '../createShipment/FreightOptions.vue';
import { InProgress } from '../../types';

@Component({
  components: {
    FreightOptions,
  },
})
export default class FreightOptionsModal extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  @PropSync('isFreightFormChanged', {
    required: false, default: false,
  }) syncedIsFreightFormChanged!: boolean;

  private shipFrom: ShipFromType = {
    isInside: false,
    isTailGate: false,
    isTradeShow: false,
    isLimitedAccess: false,
  }

  private shipTo: ShipToType = {
    isInside: false,
    isTailGate: false,
    isTradeShow: false,
    isLimitedAccess: false,
    appointment: {
      appointmentType: 'None',
      date: moment().format('YYYY-MM-DD'),
      time: moment('12:00', 'HH:mm').format('HH:mm'),
    },
  };

  private isSubmitting = false;

  get inProgressData(): InProgress {
    return this.$store.getters.getInProgress;
  }

  private update(shipFrom: ShipFromType, shipTo: ShipToType) {
    this.shipFrom = shipFrom;
    this.shipTo = shipTo;
  }

  private async submit() {
    const { fromAddress, toAddress, packages } = this.inProgressData;

    const payload: InProgress = {
      ...this.inProgressData,
      fromAddress: {
        ...fromAddress,
        ...this.shipFrom,
      },
      toAddress: {
        ...toAddress,
        ...this.shipTo,
      },
    };

    this.$store.commit('setInProgress', payload);

    this.isSubmitting = true;
    await this.$store.dispatch('syncInProgressData');

    if (this.syncedIsFreightFormChanged) {
      await this.$store.dispatch('getRates', {
        packages: packages.map((p) => ({ ...p, packageType: 'Pallet' })),
      });
    }

    this.isSubmitting = false;
    this.$emit('next');

    this.syncedShow = false;
  }
}
